import { addDays, getDate, getMonth, isEqual, startOfDay } from "date-fns";
import React from "react";
import { IconType } from "react-icons";
import {
  PiMoon,
  PiMoonFill,
  PiSun,
  PiSunFill,
  PiSunHorizon,
  PiSunHorizonFill,
} from "react-icons/pi";
import { TimeRange, allTimeRanges } from "../../SearchBar/SearchProvider";

type TimeRangeIncluded = TimeRange | `${TimeRange}Included`;

export const formatMonth = (date: Date) =>
  date.toLocaleDateString("en-US", { month: "short" });

export const timeRangeToIcon: Record<TimeRangeIncluded, IconType> = {
  afternoon: PiSun,
  afternoonIncluded: PiSunFill,
  evening: PiMoon,
  eveningIncluded: PiMoonFill,
  morning: PiSunHorizon,
  morningIncluded: PiSunHorizonFill,
};

type FormatDateRangeArgs = {
  from: Date;
  until: Date;
  timeRanges?: TimeRange[];
  gap?: React.CSSProperties["gap"];
};
export const FormatDateRange = ({
  from,
  until,
  gap = "0.5rem",
  timeRanges,
}: FormatDateRangeArgs) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap,
      }}
    >
      {formatDateRange(from, until)}
      {timeRanges && FormatTimeRanges({ timeRanges })}
    </div>
  );
};

export const formatDateRange = (from: Date, until: Date) =>
  `${formatMonth(from)} ${getDate(from)}${
    !isEqual(from, until) && until
      ? ` - ${
          !(getMonth(from) === getMonth(until)) ? formatMonth(until) : ""
        } ${getDate(until)}`
      : ""
  }`;

export const defaultDateRange = () => {
  const today = startOfDay(new Date());
  return { from: today, until: addDays(today, 3) };
};

type FormatTimeRangesProps = { timeRanges: TimeRange[] };

export function FormatTimeRanges({
  timeRanges,
}: FormatTimeRangesProps): React.ReactNode {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {allTimeRanges.map((timeRange) => {
        const timeRangeIsIncluded = timeRanges.includes(timeRange);
        const iconKey = `${timeRange}${timeRangeIsIncluded ? "Included" : ""}`;
        const Icon = timeRangeToIcon[iconKey];

        return (
          <Icon
            key={timeRange}
            style={{
              opacity: timeRangeIsIncluded ? 1 : 0.3,
            }}
          />
        );
      })}
    </div>
  );
}
